import $ from 'jquery';
$(document).ready(() => {
    $(function() {
        var $temp = $("<input>");
        var $url = $(location).attr('href');

        $('.clipboard').on('click', function() {
            $("body").append($temp);
            $temp.val($url).select();
            document.execCommand("copy");
            $temp.remove();
            $('.copied').text("URL copié!").show().fadeOut(1200);
        })
    });

})

